<template>
	<div>
		<div v-if="productInfo.visible" class="add-order-box-activated mb-0"
			 @click="productInfo.enabled ? selection($event, productInfo.product_type) : null">
			<div class="is-flex is-flex-direction-row">
				<div>
						<span class="icon add-order-icon">
							<i class="monizze-icon" :class="['monizze-icon-product-' + productInfo.product_type]"></i>
						</span>
				</div>
				<div class="has-text-weight-bold add-order-product has-text-centered-mobile">
					{{ translations.products[productInfo.product_type + '_voucher'] }} <span v-if="productInfo.service" class="tag is-info" style="background-color: #0096B5 !important"> {{ translations.products.new }}</span>
				</div>

				<div class="is-marged-right has-text-right add-order-infos" v-if="productInfo.product_type !== 'lmv' && (productInfo.is_discoverable || !productInfo.has_placed_order)">
					<a :href="productInfo.discover_url"
					   data-ta-event="clientarea-track.order.new-order.see-offer"
					   data-ta-action="Click"
					   data-ta-label="Order-page – New Order – Click on see offer link of products available"
					   data-ta-page-name="NewOrderPage"
					   :data-ta-payload="JSON.stringify({'product': productInfo.product_type})"
					   class="track-action discover-cta"
					>
						{{translations.discover}}
					</a>
				</div>
				<div class="is-marged-right is-hidden-mobile has-text-right add-order-infos" v-else>
					<div v-if="productInfo.ordered_by !== 'customer'">
							<span class="icon is-small is-right is-clickable">
								<a>
									<i class="fa-solid fa-circle-info"></i>
								</a>
							</span>
						{{ productInfo.ordered_by === 'socsec' ? translations.orderedBy[ productInfo.ordered_by ].replace(':socsec', productInfo.socsec_name) : translations.orderedBy[ productInfo.ordered_by ] }}
					</div>
					<div v-if="productInfo.auto_order">
						<div v-if="productInfo.ordered_by !== 'customer'" class="auto-order-box-desktop">
							<strong class="has-text-black format-text is-uppercase">
								{{ translations.autoOrder.warning }}
							</strong>
						</div>
						<div v-else class="auto-order-box-desktop-alone">
							<strong class="has-text-black format-text is-uppercase">
								{{ translations.autoOrder.warning }}
							</strong>
						</div>
					</div>
				</div>
			</div>
			<div class="is-hidden-desktop is-hidden-tablet is-marged-left">
				<div v-if="productInfo.ordered_by !== 'customer'">
						<span class="icon is-small is-right is-clickable">
							<a>
								<i class="fa-solid fa-circle-info"></i>
							</a>
						</span>
					{{ translations.orderedBy[ productInfo.ordered_by ].replace(':socsec', productInfo.socsec_name) }}
				</div>
				<div v-if="productInfo.auto_order" class="auto-order-box-mobile mb-3">
					<strong class="has-text-black">
						{{ translations.autoOrder.warning }}
					</strong>
				</div>
			</div>
		</div>

		<template v-if="selected">
			<div
				class="add-order-box collapsible-product-order-content is-flex is-flex-direction-row is-align-items-center is-flex-wrap-wrap track-action"
				@click="clickMakeOrder(productInfo.product_type)"
				data-ta-event="clientarea-track.order.new-order.start-order"
				data-ta-action="Click"
				data-ta-label="Order-page - Intent to start new order"
				data-ta-page-name="NewOrderPage"
				:data-ta-payload="JSON.stringify({'product': productInfo.product_type, 'method': 'manual-order' })"
			>
				<div class="is-flex is-align-items-center">
					<span class="icon is-vertical-align is-48x48 mr-2">
						<i class="fa-thin fa-pen fa-2x monizze-color"></i>
					</span>
					<div>
						<ul>
							<li class="has-text-weight-bold">{{ translations.create.manual_order.title }}</li>
							<li>{{ translations.create.manual_order.description }}</li>
						</ul>
					</div>
				</div>

				<div class="is-flex ml-tag-recommended" v-if="productInfo.recommend_manual_order">
					<span class="tag is-recommended is-uppercase has-text-weight-bold format-text">{{ translations.create.recommend }}</span>
				</div>
			</div>

			<div v-if="productInfo.auto_order_allowed && !productInfo.auto_order && productInfo.visible_auto_order"
				 class="add-order-box collapsible-product-order-content is-flex is-flex-direction-row is-align-items-center is-flex-wrap-wrap track-action"
				 @click="activateAutoOrder(productInfo.product_type)"
				 data-ta-event="clientarea-track.order.new-order.start-order"
				 data-ta-action="Click"
				 data-ta-label="Order-page - Intent to start new order"
				 data-ta-page-name="NewOrderPage"
				 :data-ta-payload="JSON.stringify({'product': productInfo.product_type, 'method': 'auto-order' })"
			>
				<div class="is-flex is-align-items-center">
					<span class="icon is-vertical-align is-48x48 mr-2">
						<i class="fa-thin fa-repeat fa-2x monizze-color"></i>
					</span>
					<div>
						<ul>
							<li class="has-text-weight-bold">{{ translations.create.auto_order.title }}</li>
							<li>{{ translations.create.auto_order.description }}</li>
						</ul>
					</div>
				</div>

				<div class="is-flex ml-tag-recommended" v-if="productInfo.recommend_auto_order">
					<span class="tag is-recommended is-uppercase has-text-weight-bold format-text">{{ translations.create.recommend }}</span>
				</div>
			</div>

			<div
				class="add-order-box collapsible-product-order-content is-flex is-flex-direction-row is-align-items-center is-flex-wrap-wrap track-action"
				@click="clickImportOrder(productInfo.product_type)"
				data-ta-event="clientarea-track.order.new-order.start-order"
				data-ta-action="Click"
				data-ta-label="Order-page - Intent to start new order"
				data-ta-page-name="NewOrderPage"
				:data-ta-payload="JSON.stringify({'product': productInfo.product_type, 'method': 'import-file' })"
			>
				<div class="is-flex is-align-items-center">
					<span class="icon is-vertical-align is-48x48 mr-2">
						<i class="fa-thin fa-file-import fa-2x monizze-color"></i>
					</span>
					<div>
						<ul>
							<li class="has-text-weight-bold">{{ translations.create.import_file.title }}</li>
							<li>{{ translations.create.import_file.description }}</li>
						</ul>
					</div>
				</div>

				<div class="is-flex ml-tag-recommended" v-if="productInfo.recommend_import_file">
					<span class="tag is-recommended is-uppercase has-text-weight-bold format-text">{{ translations.create.recommend }}</span>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		productInfo: {
			type: Object,
			required: true
		},
		translations: {
			type: Object,
			required: true
		},
		selected: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		selection: function (event, product) {
			// prevent open options when user just clicks on the discover link
			if (event && event.target.matches(".discover-cta"))
			{
				return;
			}

			this.$emit('product-selected', product);
		},
		clickMakeOrder: function (product) {
			this.$emit('order-selected', product);
		},
		activateAutoOrder: function (product) {
			this.$emit('activate-auto-order', product);
		},
		clickImportOrder: function (product) {
			this.$emit('import-file', product);
		}
	},
}
</script>

<style>
</style>
